import { Grid, styled } from '@mui/material';

export const VerticalAssetContainer = styled(Grid)(() => ({
  display: 'inline-block',
  minHeight: '12.9rem'
}));

export const AssetControl = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0.75),
  height: '4.3rem'
}));

export const AssetImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  display: 'block',
  margin: 'auto',
  objectFit: 'contain'
}));

export const AssetImageContainer = styled(Grid)(() => ({
  height: '17.2rem'
}));
